import FilterChip from 'components/Luxkit/Chips/FilterChip'
import DropdownChevron from 'components/Luxkit/Dropdown/DropdownChevron'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import { countOccupants, formatOccupantsForSelectionBox, generateRoomOccupants } from 'lib/offer/occupancyUtils'
import { isTourV2Offer } from 'lib/offer/offerTypes'
import { isSalesforceTourV2 } from 'lib/offer/offerUtils'
import { pluralizeToString } from 'lib/string/pluralize'
import React, { useMemo } from 'react'

interface Props {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  selected?: boolean;
  rooms?: Array<App.Occupants>;
  variant?: 'dropdown' | 'modal';
  offer: App.Offer | App.BedbankOffer | App.Tours.TourV2Offer;
  disableMultiRoom?: boolean;
}

const defaultRooms = [generateRoomOccupants()]
const OfferCalendarCapacityChip = React.forwardRef<HTMLButtonElement, Props>(
  function OfferCalendarCapacityChip(props, ref) {
    const { onClick, rooms = defaultRooms, offer, selected, variant, disableMultiRoom } = props

    const allRooms = useMemo(() => countOccupants(rooms), [rooms])
    const value = useMemo(() => {
      if (rooms.length > 0) {
        const occupantsText = formatOccupantsForSelectionBox(isTourV2Offer(offer) && isSalesforceTourV2(offer), allRooms)
        const roomText = disableMultiRoom ? '' : pluralizeToString(offer.saleUnit, rooms.length)
        return `${occupantsText} ${roomText ? ` (${roomText})` : ''}`
      }

      return 'Select guests'
    }, [allRooms, disableMultiRoom, offer, rooms.length])

    return <FilterChip
      size="medium"
      ref={ref}
      onClick={onClick}
      endIcon={variant === 'dropdown' ? <DropdownChevron open={selected} /> : undefined}
      selected={selected}
    >
      {value}
    </FilterChip>
  },
)

type MappedProps = Pick<Props, 'rooms'>

export default withOfferPageState((state): MappedProps => ({
  rooms: state.rooms,
}), OfferCalendarCapacityChip)
